// @flow
import React, { useState, useEffect, useRef } from "react";
import { Button } from "@material-ui/core";
import InputField from "../../../components/ui/inputField";
import ValidatedDatePicker from "../../../components/ui/DatePicker";
import axios from "../../../axios-order";
import {
  ValidatorForm,
  resetValidations,
} from "react-material-ui-form-validator";
import { toast } from "react-toastify";

import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";

export default function Add(props) {
  const { cancelAddForm, updateGetApi } = props;
  const addForm = useRef();
  // const form = useRef("form")
  const [addTdsData, setAddTdsData] = useState({});
  const [fromDate, setFromDate] = useState(null);
  const [sectionDropdown, setSectionDropdown] = useState([]);

  // --- New State for Dependent Dropdowns ---
  const [sectionMapping, setSectionMapping] = useState([]);
  const [sectionOptions, setSectionOptions] = useState([]);
  const [sectionNewOptions, setSectionNewOptions] = useState([]);

  useEffect(() => {
    fetchSectionDropdown();
  }, []);

  const fetchSectionDropdown = () => {
    axios
      .get("/get_tds_section_dropdown")
      .then((res) => {
        const apiData = res.data.record || res.data;
        setSectionMapping(apiData); // Store the raw mapping
        setSectionDropdown(apiData); // Keep existing state if used elsewhere

        // Populate initial Section dropdown
        const sections = apiData.map((item) => ({ section: item.section }));
        setSectionOptions(sections);

        // Populate initial New Section dropdown with all values (deduplicated)
        const allNewSections = apiData.flatMap((item) =>
          item.section_new.map((s) => ({ section_new: s }))
        );
        const uniqueNewSections = Array.from(
          new Set(allNewSections.map((a) => a.section_new))
        ).map((sn) => ({ section_new: sn }));
        
        setSectionNewOptions(uniqueNewSections);
      })
      .catch((err) => {
        console.error("Error fetching section dropdown:", err);
      });
  };

  const addInputChangeHandler = (e) => {
    let name = e.target.name;
    let value = e.target.value;

    // Logic for Section Change
    if (name === "tds_section") {
      const matched = sectionMapping.find((item) => item.section === value);
      const newFilteredOptions = matched
        ? matched.section_new.map((s) => ({ section_new: s }))
        : [];
      
      setSectionNewOptions(newFilteredOptions);

      // Auto-select section_new if only one option exists
      const autoValue = newFilteredOptions.length === 1 ? newFilteredOptions[0].section_new : "";
      
      setAddTdsData({
        ...addTdsData,
        tds_section: value,
        section_new: autoValue,
      });
      return;
    }

    // Logic for Section New Change
    if (name === "section_new") {
        // Find which sections contain this new_section
        const matchedSections = sectionMapping.filter(item => 
            item.section_new.includes(value)
        );

        // If it belongs to only one parent section, auto-select it
        const autoSection = matchedSections.length === 1 ? matchedSections[0].section : addTdsData.tds_section;

        setAddTdsData({
            ...addTdsData,
            section_new: value,
            tds_section: autoSection
        });
        return;
    }

    setAddTdsData({
      ...addTdsData,
      [name]: value,
    });
  };

  const handleFromDateChange = (v) => {
    setFromDate(v);
    setAddTdsData({
      ...addTdsData,
      valid_to_date: null,
    });
    if (v != "Invalid Date" && v != null) {
      const pad = "00";
      const yy = v.getFullYear().toString();
      const mm = (v.getMonth() + 1).toString();
      const dd = v.getDate().toString();
      setAddTdsData({
        ...addTdsData,
        valid_from_date: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(
          -2
        )}`,
      });
    }
  };

  const handleToDateChange = (v) => {
    if (v != "Invalid Date" && v != null) {
      const pad = "00";
      const yy = v.getFullYear().toString();
      const mm = (v.getMonth() + 1).toString();
      const dd = v.getDate().toString();
      setAddTdsData({
        ...addTdsData,
        valid_to_date: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`,
      });
    }
  };

  const handleSectionChange = (e) => {
    // Redirecting to the main handler to use the logic implemented there
    addInputChangeHandler(e);
  };

  const finalAddData = {
    org_gstin: `${localStorage.getItem("gst")}`,
    records: [addTdsData],
  };

  const addFormsubmitHandler = (e) => {
    if (addTdsData.valid_to_date < addTdsData.valid_from_date) {
      alert("To Date is lesser than From date");
      return false;
    }
    if (!addTdsData.TDSType) {
      alert("Please Select the TDS Type.");
      return false;
    }
    axios
      .post("/tds/exemption", finalAddData)
      .then((res) => {
        if (res.data.status === true) {
          cancelAddForm();
          updateGetApi();
          setAddTdsData({});

          toast.success(res.data.message, { autoClose: 2000 });
        } else {
          toast.error(res.data.message, { autoClose: 2000 });
        }
      })
      .catch((err) => {});
  };

  const cancelAddFormDrawer = () => {
    cancelAddForm();
    setAddTdsData({});

    addForm.current.resetValidations();
  };

  return (
    <ValidatorForm
      ref={addForm}
      onSubmit={addFormsubmitHandler}
      onError={(errors) => console.log(errors)}
    >
      <FormControl>
        {/* <FormLabel id="demo-controlled-radio-buttons-group">TDS Type</FormLabel> */}
        <label style={{ marginBottom: "0px" }}>TDS Type</label>
        <RadioGroup
          row
          aria-labelledby="demo-controlled-radio-buttons-group"
          name="TDSType"
          value={addTdsData.TDSType ?? ""}
          onChange={addInputChangeHandler}
        >
          <FormControlLabel value="Sales" control={<Radio />} label="Sales" />
          <FormControlLabel
            value="Purchase"
            control={<Radio />}
            label="Purchase"
          />
        </RadioGroup>
      </FormControl>

      <InputField
        textLabel="Legal Name"
        inputType="text"
        inputProps={{ maxLength: 100 }}
        name="vendor_legal_name"
        value={addTdsData.vendor_legal_name ?? ""}
        requiredField="*"
        validator={["required"]}
        errorMsg={["This field is required"]}
        textOnchangeFunction={addInputChangeHandler}
      />

      <InputField
        textLabel="PAN"
        inputType="text"
        inputProps={{ maxLength: 10 }}
        name="pan"
        value={addTdsData.pan ?? ""}
        requiredField="*"
        validator={["required"]}
        errorMsg={["This field is required"]}
        textOnchangeFunction={addInputChangeHandler}
      />

      <div style={{ marginTop: "20px" }}>
        <label>
          From Date
          <span style={{ color: "red" }}>*</span>:
        </label>
        <ValidatedDatePicker
          name="valid_from_date"
          value={addTdsData.valid_from_date ?? ""}
          onChange={(v) => handleFromDateChange(v)}
          validators={["required"]}
          errorMessages={["This field is required"]}
        />
      </div>

      <div style={{ marginTop: "20px" }}>
        <label>
          To Date
          <span style={{ color: "red" }}>*</span>:
        </label>
        <ValidatedDatePicker
          minDateForDatepicker={fromDate ?? ""}
          name="to_date"
          value={addTdsData.valid_to_date ?? ""}
          onChange={(v) => handleToDateChange(v)}
          validators={["required"]}
          errorMessages={["This field is required"]}
          disabled={fromDate ? false : true}
        />
      </div>

      <div style={{ marginTop: "20px" }}>
        <label>
          Section
          <span style={{ color: "red" }}>*</span>:
        </label>
        <FormControl fullWidth style={{ marginTop: "8px" }}>
          <Select
            name="tds_section"
            value={addTdsData.tds_section ?? ""}
            onChange={handleSectionChange}
            style={{ height: "40px" }}
            displayEmpty
          >
            {sectionOptions.map((item, index) => (
              <MenuItem key={index} value={item.section}>
                {item.section}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>

      {/* --- New Section Dropdown --- */}
      <div style={{ marginTop: "20px" }}>
        <label>
          New Section
          <span style={{ color: "red" }}>*</span>:
        </label>
        <FormControl fullWidth style={{ marginTop: "8px" }}>
          <Select
            name="section_new"
            value={addTdsData.section_new ?? ""}
            onChange={addInputChangeHandler}
            style={{ height: "40px" }}
            displayEmpty
          >
            {sectionNewOptions.map((item, index) => (
              <MenuItem key={index} value={item.section_new}>
                {item.section_new}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>

      <InputField
        textLabel="Description"
        inputType="text"
        name="description"
        value={addTdsData.description ?? ""}

        // requiredField="*"
        // validator={["required"]}
        // errorMsg={["This field is required"]}
        textOnchangeFunction={addInputChangeHandler}
      />

      {/* .......Button........ */}
      <div className="mt-20">
        <button className="button-primary" type="submit">
          Submit
        </button>
        <button
          className="button-outlined-secondary"
          type="button"
          onClick={cancelAddFormDrawer}
        >
          cancel
        </button>
      </div>
    </ValidatorForm>
  );
}